import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';

const FormCancelButton = (props) => {

  let {
    onClick,
    loading,
  } = props;

  return (
    <Button className={'form-cancel-button'} variant="link"
            disabled={loading}
            onClick={onClick}>キャンセル</Button>
  );

};

FormCancelButton.propTypes = {
  onClick: PropTypes.func,
};

export default FormCancelButton;
